<template>
  <van-popup v-model="dsShow" class="dashi-box" @close="doClose" closeable>
    <van-skeleton title avatar :row="10" :loading="dsLoad">
      <div v-if="dashi" class="dashi">
        <van-row type="flex" justify="center" style="margin-top: -30px">
          <van-image
            :src="dashi.avatar"
            class="avatar"
            width="70"
            height="70"
            round
          />
        </van-row>
        <van-row type="flex" justify="center" class="nickname">
          <van-col>{{ dashi.nickname }}</van-col>
        </van-row>
        <van-row type="flex" align="center" class="acount">
          <van-col span="6">微信</van-col>
          <van-col span="14" class="val">{{ dashi.wx }}</van-col>
          <van-col span="6" v-if="dashi.wx">
            <van-button size="small" icon="orders-o" @click="doCopy(dashi.wx)"
              >复制</van-button
            >
          </van-col>
        </van-row>
        <van-row type="flex" align="center" class="acount">
          <van-col span="6">Q Q</van-col>
          <van-col span="14" class="val">{{ dashi.qq }}</van-col>
          <van-col span="6" v-if="dashi.qq">
            <van-button size="small" icon="orders-o" @click="doCopy(dashi.qq)"
              >复制</van-button
            >
          </van-col>
        </van-row>
        <van-row
          type="flex"
          justify="center"
          align="center"
          class="qrcodebox"
          v-if="dashi.qrcode"
        >
          <van-image
            :src="dashi.qrcode"
            class="qrcode"
            width="100"
            height="100"
          />
          <div class="txt-green">
            复制扫一扫
            <br />推荐截图保存
          </div>
        </van-row>
      </div>
    </van-skeleton>
  </van-popup>
</template>

<script>
import { copyText } from 'clipboard-vue'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      dashi: null,
      dsShow: false,
      dsLoad: true
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 直传sellid
    saleid: {
      type: String,
      default: ''
    }
  },
  watch: {
    show(vo) {
      this.dsShow = vo
      if (!this.dashi && vo) {
        this.getDashi()
      }
    }
  },
  computed: {
    ...mapState(['sellid'])
  },
  mounted() {
    this.dsShow = this.show
  },
  methods: {
    doCopy(vo) {
      copyText(vo)
        .then(() => {
          this.$dialog({ message: '复制成功，请添加师傅！' })
        })
        .catch(() => {
          this.$dialog({ message: '复制失败，请长按号码复制！' })
        })
    },
    doClose() {
      console.log('close')
      this.$store.commit('setDsShow', false)
      //this.$emit('update:show', false)
    },
    getDashi() {
      this.dsLoad = true
      let params = {}
      let gid = this.$route.query.gid
      let sellid = this.saleid || this.sellid
      if (sellid) {
        params.sellid = sellid
      } else if (gid) {
        params.gid = gid
      }
      console.log('sellid', params)
      this.$axios.get('/crm/dashi', { params }).then((res) => {
        this.dashi = res.data
        this.dsLoad = false
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.txt-green {
  color: #090;
}
.dashi-box {
  width: 92%;
  max-width: 480px;
  padding-bottom: 16px;
  overflow: visible;
  border-radius: 10px;
}
.dashi {
  padding: 0 15px;

  .nickname {
    padding: 5px 0;
    font-size: 1.4em;
    font-weight: bold;
  }
  .avatar {
    border: #fff solid 5px;
  }
  .acount {
    padding: 5px 0;
    .val {
      text-align: left;
      font-weight: bold;
      user-select: auto;
      -webkit-user-select: auto;
    }
  }
  .qrcodebox {
    flex-direction: column;
  }
  .qrcode {
    border: #eee solid 1px;
    margin: 5px;
  }
}
</style>